module.exports = __webpack_public_path__ + "static/media/viola.5d09befc.png";